// EDIT CONTACT DETAILS HERE — placeholders, update before going live.
export const SITE = {
  name: "SwiftTest Solutions LLC",
  shortName: "SwiftTest",
  tagline: "Professional testing that works at your location and schedule",
  phoneDisplay: "(319) 302-9089",
  phoneTel: "+13193029089",
  phoneSms: "3193029089",
  email: "info@swifttestsolutions.com",
  hours: "24/7 dispatch for urgent & post-accident testing",
  serviceRadius: "~100-mile service radius",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Mobile Testing", path: "/mobile-testing" },
  { label: "Service Area", path: "/service-area" },
  { label: "About", path: "/about" },
  { label: "FAQ", path: "/faq" },
  { label: "Payments", path: "/payments" },
  { label: "Contact", path: "/contact" },
];
